import { Injectable } from '@angular/core';
import { IProductionDetailLayout } from '../models/layout/production-detail-layout.model';
import { IProductionLayout } from '../models/layout/production-layout.model';

@Injectable({
    providedIn: 'root',
})
export class ProductionLayoutService {

    constructor() {
    }

    public getProductionLayout(): IProductionLayout {
        return {
            columns: [ 'productionOrderNr', 'articleNrs', 'costUnits', 'date' ],
        };
    }

    public getProductionDetailLayout(): IProductionDetailLayout {
        return {
            productionEntryColumns: [ 'articleNr', 'name', 'amount', 'measureUnit', 'price', 'type' ],
            productionExitColumns: [ 'articleNr', 'name', 'amount', 'measureUnit', 'type' ],
        };
    }
}
